import React from 'react';
import PropTypes from 'prop-types';

import * as style from './ArticleQuote.module.scss';
import ArticleList from '../ArticleList';

/** Quote block with black stripe to the left. */
const ArticleQuote = (props) => {
  const { text } = props;

  return (
    <div className={style.quote}>
      <div className={style.verticalDash} />
      <div className={style.quoteText}>{text}</div>
    </div>
  );
};

ArticleList.propTypes = {
  /** The text of a quote. */
  text: PropTypes.string.isRequired,
};

export default ArticleQuote;
